import type { TableTone } from '../types'

type ToneStyle = { swatch: string; header: string; input: string; divider: string }

const DARK_INPUT = 'text-white placeholder:text-white/55 focus:bg-white/10'

export const TABLE_TONES: Record<TableTone, ToneStyle> = {
  primary: { swatch: 'bg-primary', header: 'bg-primary text-white', input: DARK_INPUT, divider: 'border-white/15' },
  navy: { swatch: 'bg-brand-navy', header: 'bg-brand-navy text-white', input: DARK_INPUT, divider: 'border-white/15' },
  sky: { swatch: 'bg-brand-sky', header: 'bg-brand-sky text-white', input: DARK_INPUT, divider: 'border-white/20' },
  orange: { swatch: 'bg-brand-orange', header: 'bg-brand-orange text-white', input: DARK_INPUT, divider: 'border-white/20' },
  dark: {
    swatch: 'bg-foreground',
    header: 'bg-foreground text-background',
    input: 'text-background placeholder:text-background/55 focus:bg-background/10',
    divider: 'border-background/15',
  },
  light: {
    swatch: 'bg-primary/15 ring-1 ring-inset ring-primary/30',
    header: 'bg-primary/10 text-brand-navy dark:text-foreground',
    input: 'text-brand-navy placeholder:text-brand-navy/45 focus:bg-primary/10 dark:text-foreground',
    divider: 'border-primary/15',
  },
}

export const TABLE_TONE_KEYS = Object.keys(TABLE_TONES) as TableTone[]
